/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnthropicLogo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.42 5h-3.06l5.58 14H22zM7.58 5 2 19h3.12l1.141-2.94H12.1L13.24 19h3.12L10.78 5zm-.31 8.46 1.91-4.92 1.91 4.92z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAnthropicLogo as AnthropicLogo };
